import { access } from '@solid-primitives/utils';
import { createResource, onCleanup, createEffect, on } from 'solid-js';
import { isServer } from 'solid-js/web';

// src/index.ts
var writeClipboard = async (data) => {
  if (isServer) {
    return;
  }
  typeof data === "string" ? await navigator.clipboard.writeText(data) : await navigator.clipboard.write(data);
};
function readClipboard() {
  if (isServer) {
    return Promise.resolve([]);
  }
  return navigator.clipboard.read();
}
var makeClipboard = () => {
  return [writeClipboard, readClipboard, newClipboardItem];
};
var createClipboard = (data, deferInitial) => {
  if (isServer) {
    return [
      Object.assign(() => [], { loading: false, error: void 0 }),
      () => void 0,
      async () => void 0
    ];
  }
  let init = true;
  const [clipboard, { refetch }] = createResource(
    async (_, info) => {
      if (init) {
        init = false;
        return info.value;
      }
      try {
        const items = await readClipboard();
        if (!items.length)
          return [];
        return Promise.all(
          items.map(async (item) => {
            const type = item.types[item.types.length - 1];
            const blob = await item.getType(type);
            const text = blob.type === "text/plain" ? await blob.text() : void 0;
            return { type, blob, text };
          })
        );
      } catch {
        return [];
      }
    },
    { initialValue: [] }
  );
  navigator.clipboard.addEventListener("clipboardchange", refetch);
  onCleanup(() => navigator.clipboard.removeEventListener("clipboardchange", refetch));
  if (data) {
    createEffect(on(data, () => writeClipboard(data()), { defer: deferInitial || true }));
  }
  return [clipboard, refetch, writeClipboard];
};
var copyToClipboard = (el, options) => {
  if (isServer) {
    return void 0;
  }
  const setValue = () => {
    const opts = access(options);
    let data = opts.value;
    if (!data) {
      data = el[["input", "texfield"].includes(el.tagName.toLowerCase()) ? "value" : "innerHTML"];
    }
    let write;
    if (opts.setter) {
      write = opts.setter;
    } else {
      write = async (data2) => await navigator.clipboard.writeText(data2);
    }
    if (opts.highlight)
      opts.highlight(el);
    write(data);
  };
  el.addEventListener("click", setValue);
  onCleanup(() => el.removeEventListener("click", setValue));
};
var newClipboardItem = (type, data) => new ClipboardItem({ [type]: data });
var newItem = newClipboardItem;
var element = (start = 0, end = 0) => {
  return (node) => {
    const text = node.childNodes[0];
    const range = new Range();
    range.setStart(text, start);
    range.setEnd(text, end);
    const selection = document.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  };
};
var input = (start, end) => {
  return (node) => {
    node.setSelectionRange(start || 0, end || node.value.length);
  };
};

export { copyToClipboard, createClipboard, element, input, makeClipboard, newClipboardItem, newItem, readClipboard, writeClipboard };
